export function ProfileLevelModel() {
    this.currentLevel = null;
    this.nextLevel = null;
    this.point = 0;
    this.pointToNextLevel = 0;
    this.expireDate = null;
    this.levelDetail = [];
    this.progress = 0;

    this.setDataFromApi = function (data) {
        this.currentLevel = data.CurrentLevel;
        this.nextLevel = data.NextLevel;
        this.point = data.Point;
        this.pointToNextLevel = data.PointToNextLevel;
        this.expireDate = data.ExpireDate;
        this.levelDetail = data.level;

        this.progress = this.getProgress();
    };

    this.getProgress = function () {
        let config = this.getLevelConfig();
        let minPoint = config.start_point;
        let maxPoint = config.end_point;
        let length = maxPoint - minPoint;
        let current = this.point - minPoint;

        let progress = current / length * 100;
        return progress;
    };

    this.getLevelConfig = function () {
        let level = this.levelDetail.find((item) => {
            return item.name_en == this.currentLevel;
        });
        return level;
    };
}
